@if (name) {
  <div
    class="rounded-full w-11 h-11 flex flex-shrink-0 justify-center items-center font-semibold text-base text-white"
    [ngClass]="[color]"
  >
    {{ name | initials }}
  </div>
}
